<template>
  <div v-if="job.date" id="jobPrint">
    <div class="ticket">
      <img v-if="store.logo" :src="store.logo" alt="Logo" />
      <p class="centered" style="margin-bottom: 10px">
        <span v-if="!store.logo">{{ store.name }}</span> <br />
        {{ store.address }}
        <br />{{ store.telephone }} <br />
      </p>

      <p>
        {{name === 'jobNotes' ? `Job No : ${job.jobNo}` : `Order No : ${job.jobNo}`}} <br />Date :
        {{ job.date }} <br />Customer : {{ job.name }}
        <br />Telephone : {{ job.tel }}
        <br />Advance Payment : Rs {{ job.adv }}
        <br />{{name === 'jobNotes' ? `Device : ${job.device}` : ''}}

      </p>
      <div>
        <table v-if="name !== 'jobNotes'" style="margin: -10px auto 0 auto" >
        <thead>
          <tr style="border-top: hidden">
            <th class="description" style="text-align: left; min-width: 180px;">Item</th>
            <!-- <th class="unitprice" style="text-align: left">Price</th> -->
            <th class="quantity" style="text-align: left">Qty</th>
            <!-- <th class="price" style="text-align: left">Amount</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in job.items" :key="product.barcode">
            <td class="description">{{ product.item }} {{ product.serial }}</td>
            <!-- <td class="price">{{ product.price.toLocaleString() }}</td> -->
            <td class="quantity">{{ product.quantity }}</td>
            <!-- <td class="price">{{ product.subTotal.toLocaleString() }}</td> -->
          </tr>
          <tr>
            <br />
          </tr>

        </tbody>
      </table>

      </div>

      <p class="centered">{{ store.footer }}</p>
      <p class="centered" style="margin-bottom: 10px">
        Thank You
      </p>

    </div>
  </div>
</template>

<script>
import { bus } from "../../../main";
export default {
  name: "posprinter",
  props: [
  ],
  data() {
    return {
      job: "",
      store: "",
      name: ''
    };
  },
  created() {},
  mounted() {
    this.$root.$on("jobPrint", (data) => {
      console.log("data",data)
      this.job = data.job;
      this.store = data.store;
      this.name = data.name
      this.print()
    })
  },
  methods: {
    print(item) {
      setTimeout(() => {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write(
          "<html><head><title>" + document.title + "</title>"
        );
        mywindow.document.write(
          `<link rel="stylesheet" href="../../../../static/pos80.css" type="text/css" />`
        );

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById('jobPrint').innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 200);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
  },
};
</script>

<style scoped>
td,
th,
tr,
table {
  bjob-top: 1px dotted rgb(49, 49, 49);
  bjob-collapse: collapse;
}
.centered {
  text-align: center;
  align-content: center;
}

* {
  font-size: 12px;
  font-family: "Times New Roman";
}
td.description,
th.description {
  width: 160px;
  max-width: 160px;
}

td.quantity,
th.quantity {
  width: 30px;
  max-width: 30px;
  word-break: break-all;
}

td.unitprice,
th.unitprice {
  width: 45px;
  max-width: 45px;
  word-break: break-all;
}

td.price,
th.price {
  width: 45px;
  max-width: 45px;
  word-break: break-all;
}

.ticket {
  /* width: 185px;
  max-width: 185px; */
  width: 230px;
  max-width: 230px;
  margin: 0 auto;
  text-align: center;
}


img {
  max-width: 180px;
  width: 180px;
  display: block;
  margin: 0 auto;
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/InvoiceTemplates/JobPrint.vue